// export const PUBLIC_IMAGE_FOLDER='http://192.168.25.105:8000'
export const PUBLIC_IMAGE_FOLDER='https://jobportal.devm2.com/API'